import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    width: 1100,
    alignSelf: 'center',
    alignItems: 'center',
    fontSize: '14px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#32363A',
  },
  progressContainer: {
    width: '556px',
  },
  progress: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'relative',
  },
  progressCircle: {
    zIndex: 30,
  },
  progressOne: {
    position: 'relative',
  },
  progressName: {
    marginTop: '20px',
    marginLeft: '-8px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: 'rgba(135,143,152,1)',
    position: 'absolute',
    width: '100px',
    top: '28px',
    left: '50%',
    transform: 'translateX(-42px)',
    textAlign: 'center',
  },
  circle: {
    width: '16px',
    height: '16px',
    borderRadius: '8px',
    background: 'rgba(255,255,255,1)',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #3399FF',
  },
  imgOk: {
    width: '16px',
    height: '16px',
    borderRadius: '8px',
    background: 'rgba(255,255,255,1)',
  },
  circle1: {
    width: '8px',
    height: '8px',
    borderRadius: '4px',
    background: '#3399FF',
  },
  circleGray: {
    width: '16px',
    height: '16px',
    borderRadius: '8px',
    border: '2px solid rgba(195,204,209,1)',
    background: 'rgba(255,255,255,1)',
  },
  progressLine: {
    position: 'absolute',
    top: '50%',
    transfrom: 'translateY(-50%)',
    width: '100%',
    height: '2px',
    background: 'rgba(195,204,209,1)',
  },
  text: {
    fontSize: '14px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(50,54,58,1)',
    lineHeight: '20px',
  },
  tip: {
    color: '#3399FF',
    fontFamily: 'Semibold',
    fontSize: '14px',
    fontWeight: '600',
  },
});



// WEBPACK FOOTER //
// ./src/components/testPages/welcome/styles.js